// Module
var code = "<template> <span if.bind=\"showLink\" click.delegate=\"openLink()\" class=\"${!noUnderline | toggle: 'ess-link'}\" ess-tooltip=\"text.bind: tooltip; is-described-by.bind: true;\" tabindex=\"0\" ess-focusable>${display}</span> <span else>${display}</span> </template> ";
// Exports
module.exports = code;